import fileDownload from 'js-file-download';
import request from './request';
import {AxiosRequestConfig} from 'axios';

export const downloadAllResults = async () => {
  const url = 'lesson/subscription/results';
  await resultDownload(url, 'results.zip');
};

export const downloadUserResults = async (userId?: string) => {
  const url = 'lesson/subscription/results';
  await resultDownload(url, 'results.zip', userId);
};

export const downloadResult = async (id: string, userId?: string) => {
  const url = `/lesson/${id}/subscription/results`;
  await resultDownload(url, `result-${id}.csv`, userId);
};

/**
 * Local function to handle downloading of functions `downloadAllResults` and
 * `downloadResult`
 * @param url Request url
 * @param filename Filename of the downloaded file
 * @param userId Current user id. If provided, results will be filtered to only show items created by this user
 */
async function resultDownload(url: string, filename: string, userId?: string) {
  const params = userId
    ? {
        query: `created.id==${userId}`,
        order: '-created.date',
      }
    : {};

  const options: Partial<AxiosRequestConfig> = {
    responseType: 'blob',
    params,
  };

  const data = await request(url, options);

  fileDownload(data, filename);
}
